// extracted by mini-css-extract-plugin
module.exports = {"longevityMain":"Layout_longevityMain__G8r2R","section":"Layout_section__w86WS","contentBlur":"Layout_contentBlur__UBymP"};